export type CardCollectionLayoutHeaderProps = React.ComponentPropsWithoutRef<'div'>;

export const CardCollectionLayoutHeader = (props: CardCollectionLayoutHeaderProps): JSX.Element => (
	<div className='card-collection-layout__header'>
		{props.children}
	</div>
);
